import { olympusService as e } from "../services/olympus/olympus.service.js";
import { buildAssetFilesystemTree as t } from "@magnopus-opensource/connected-spaces-platform-web-api";
//#region src/lib/utils/asset-collection-tree.ts
var n = 1e4, r = 5e3, i = async (t) => {
	let { assets: r } = await e.client.assets.findForComponent(t, 0, n);
	return r;
}, a = (e) => e.reduce((e, t) => {
	if (!t.parentId) return e;
	let n = e.get(t.parentId) ?? [];
	return n.push(t), e.set(t.parentId, n);
}, /* @__PURE__ */ new Map()), o = (e, t) => {
	let n = [], i = /* @__PURE__ */ new Set([e]), a = [e];
	for (; a.length > 0;) {
		let o = [];
		for (let e of a) for (let r of t.get(e) ?? []) i.has(r.id) || (i.add(r.id), n.push(r), o.push(r.id));
		if (n.length > r) throw Error(`Asset collection ${e} has more than ${r} descendant collections`);
		a = o;
	}
	return n;
}, s = async (e, t) => o(t, a(await i(e))), c = async (e, n) => {
	let r = await i(e), s = o(n.id, a(r));
	return t([r.find((e) => e.id === n.id) ?? n, ...s], /* @__PURE__ */ new Map());
};
//#endregion
export { c as buildAssetPackageFilesystem, s as collectDescendantAssetCollections };
